function DeliveryScan() {
  return <div><h2>Delivery Scan & OTP Verify</h2><p>Delivery scan and OTP verification will go here.</p></div>;
}
export default DeliveryScan; 